import { getCompanies } from 'common/api/companies';

import {
    FETCH_COMPANIES,
    FETCH_COMPANIES_FAILURE,
    FETCH_COMPANIES_SUCCESS,
} from '../actionTypes';
import { proposalsActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(proposalsActions[FETCH_COMPANIES]());

    getCompanies()
        .then((response) =>
            dispatch(
                proposalsActions[FETCH_COMPANIES_SUCCESS](response.data.data),
            ),
        )
        .catch((error) =>
            dispatch(
                proposalsActions[FETCH_COMPANIES_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
